import { render } from "./ListNews.vue?vue&type=template&id=3a057f70&scoped=true"
import script from "./ListNews.vue?vue&type=script&lang=js"
export * from "./ListNews.vue?vue&type=script&lang=js"

import "./ListNews.vue?vue&type=style&index=0&id=3a057f70&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a057f70"]])

export default __exports__